
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.586 13.53c.239.069.473-.068.55-.332l2.857-9.99c.071-.264-.048-.508-.288-.581-.239-.069-.473.068-.55.332l-2.852 9.99c-.071.264.043.508.283.581v0zm4.756-1.772l3.598-3.316a.48.48 0 000-.727l-3.598-3.316c-.196-.19-.47-.185-.636.005-.168.19-.14.464.052.645l3.283 3.027-3.283 3.032c-.191.18-.22.454-.052.645.167.19.44.19.636.005v0zm-6.393.005c.201.185.47.18.637-.01.167-.19.143-.46-.048-.64L2.255 8.081l3.283-3.032c.191-.181.215-.45.048-.645-.168-.19-.436-.19-.637-.005L1.351 7.715a.487.487 0 000 .727l3.598 3.32z","fill":"currentColor","stroke":"currentColor","stroke-width":".2"}})])
          )
        }
      }
    